import styled from 'styled-components'

type Info = {
  color?: string
  background?: string
  border?: string
}

export const Container = styled.div<Info>`
  display: flex;
  flex-direction: row;
  flex: 1;
  gap: 1rem;
  background-color: ${(props) => props.background};
  border-radius: 6px;
  border: 1px solid ${(props) => props.border};
  padding: 1rem;
  /* max-width: 15rem; */
  min-width: 15rem;
`

export const Icon = styled.div`
  margin-top: 0.5rem;
`

export const Info = styled.div<Info>`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  > h2 {
    font-size: ${(props) => props.theme.font.text4xl};
    color: ${(props) => props.color};
  }

  > span {
    font-size: ${(props) => props.theme.font.textsm};
    color: ${(props) => props.color};
  }
`
